/* BAEZ brand layer: cleans the inline styles pasted into policy pages so the
   dark BAEZ styling in baez-brand.css can apply. Boxes become .bz-callout,
   bold spans become .bz-b, everything else just loses its inline style. */
(function () {
  function clean() {
    var root = document.querySelector('.shopify-policy__body');
    if (!root) return;
    root.querySelectorAll('[style]').forEach(function (el) {
      var s = (el.getAttribute('style') || '').toLowerCase();
      if (el.tagName === 'DIV' && /background|border-left/.test(s)) el.classList.add('bz-callout');
      if (/font-weight:\s*(bold|[6-9]00)/.test(s) && !/^h[1-6]$/i.test(el.tagName)) el.classList.add('bz-b');
      el.removeAttribute('style');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clean);
  else clean();
})();

/* Any link on the store that points at BAEZ Help (footer, menus, announcement bar,
   page text) goes to help.baezonline.com in the language the shopper is browsing in.
   Old help.baez.bz links typed into menus or pages are switched over automatically. */
(function () {
  function fixHelpLinks() {
    var lang = (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'es').toLowerCase().indexOf('es') === 0 ? 'es' : 'en';
    document.querySelectorAll('a[href*="help.baez.bz"], a[href*="help.baezonline.com"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        if (u.hostname === 'help.baez.bz') u.hostname = 'help.baezonline.com';
        u.searchParams.set('lang', lang);
        a.href = u.toString();
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixHelpLinks);
  else fixHelpLinks();
})();

/* English policy page titles in Title Case ("Shipping policy" -> "Shipping Policy",
   "Terms of service" -> "Terms of Service"). Spanish titles are left as Shopify has them. */
(function () {
  function titleCase() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('en') !== 0) return;
    var h = document.querySelector('.shopify-policy__title h1');
    if (!h) return;
    var small = { of: 1, and: 1, the: 1, a: 1, an: 1, to: 1, for: 1, in: 1, on: 1, or: 1 };
    h.textContent = h.textContent.trim().split(/\s+/).map(function (w, i) {
      var lw = w.toLowerCase();
      if (i > 0 && small[lw]) return lw;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', titleCase);
  else titleCase();
})();

/* Account / login links -> a short BAEZ note that sends shoppers to BAEZ Customer Service
   instead of Shopify's customer account (which doesn't show the latest order
   info). Covers the header person icon and the "Login" link in the menu.
   Shopify-controlled spots (checkout's own "Log in", typing /account directly)
   can't be changed from the theme. */
(function () {
  var SEL = 'a[href*="customer_authentication"], a[href*="/account/login"], a[href$="/account"], a[href*="/account?"]';
  var T = {
    en: {
      h: 'Check your order with BAEZ',
      p: "Shopify and the Shop app don't always have the latest information about BAEZ orders. For the most up-to-date status, tracking and help with your order, click below.",
      go: 'BAEZ Order Status',
      close: 'Close'
    },
    es: {
      h: 'Consulta tu pedido con BAEZ',
      p: 'Shopify y la app Shop no siempre tienen la información más reciente de los pedidos BAEZ. Para ver el estado actualizado, el rastreo y recibir ayuda con tu pedido, haz clic abajo.',
      go: 'Estado de mi pedido BAEZ',
      close: 'Cerrar'
    }
  };
  function lang() {
    return (document.documentElement.lang || (window.Shopify && Shopify.locale) || 'es').toLowerCase().indexOf('es') === 0 ? 'es' : 'en';
  }
  function open() {
    var L = lang(), t = T[L];
    var old = document.getElementById('bz-acct'); if (old) old.remove();
    var w = document.createElement('div');
    w.id = 'bz-acct';
    w.setAttribute('role', 'dialog');
    w.setAttribute('aria-modal', 'true');
    w.setAttribute('aria-labelledby', 'bz-acct-h');
    w.innerHTML =
      '<div class="bz-acct__scrim" data-close></div>' +
      '<div class="bz-acct__card">' +
        '<button type="button" class="bz-acct__x" data-close aria-label="' + t.close + '">&times;</button>' +
        '<p class="bz-acct__h" id="bz-acct-h">' + t.h + '</p>' +
        '<p class="bz-acct__p">' + t.p + '</p>' +
        '<a class="bz-acct__go" href="https://help.baezonline.com/?lang=' + L + '" target="_blank" rel="noopener">' + t.go + '</a>' +
        '<button type="button" class="bz-acct__close" data-close>' + t.close + '</button>' +
      '</div>';
    document.body.appendChild(w);
    document.documentElement.classList.add('bz-acct-open');
    function close() { w.remove(); document.documentElement.classList.remove('bz-acct-open'); document.removeEventListener('keydown', esc); }
    function esc(e) { if (e.key === 'Escape') close(); }
    w.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    w.querySelector('.bz-acct__go').addEventListener('click', function () { setTimeout(close, 50); });
    document.addEventListener('keydown', esc);
    w.querySelector('.bz-acct__go').focus();
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(SEL);
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);
})();

/* ── 14. Back-in-stock email signup (2026-11-03) ─────────────────────────────
   Sold-out sizes get a small bell on their top-left corner. Picking one shows
   "Notify me when it's back" under the Sold Out button. After signing up the
   size and the button turn green ("We'll let you know when S is back in stock").
   This browser remembers the sizes it signed up for, and the server also refuses
   a second signup for the same email + size, so nobody signs up twice.
   Posts to the Supabase function restock-email-signup, which runs the same email
   checks as every other BAEZ form (honeypot, confirm field, typo / disposable /
   bounce checks, SendGrid validation, rate limits). One email per size. */
(function () {
  var ENDPOINT = 'https://qfgohgxqklovkqchxezl.supabase.co/functions/v1/restock-email-signup';
  var STORE_KEY = 'bz_restock_v1';
  var ES = /^es/i.test(document.documentElement.lang || '');
  var T = ES ? {
    h: 'Avísame cuando vuelva',
    sub: function (s) { return (s ? 'La talla ' + s + ' está agotada. ' : 'Este producto está agotado. ') + 'Déjanos tu correo y te enviamos un solo aviso cuando vuelva.'; },
    email: 'Correo electrónico', confirm: 'Confirma tu correo',
    optin: 'Sí, quiero recibir correos de BAEZ con drops y promociones exclusivas. Puedo darme de baja en cualquier momento.',
    btn: 'Avísame', sending: 'Enviando…',
    done: function (s) { return 'Te avisaremos cuando ' + (s ? 'la talla ' + s : 'este producto') + ' vuelva'; },
    doneSub: 'Te enviaremos un solo correo cuando vuelva a estar disponible.',
    already: function (s) { return 'Ya estás registrado para ' + (s ? 'la talla ' + s : 'este producto') + '. Te avisaremos cuando vuelva.'; },
    bell: 'Agotado: avísame cuando vuelva', bellOn: 'Ya te avisaremos cuando vuelva',
    pick: 'Elige tu talla arriba y luego deja tu correo. Te enviaremos un solo aviso cuando vuelva.',
    mean: '¿Quisiste decir', fix: 'Corregir',
    err: { invalid_email: 'Revisa tu correo electrónico.', typo_domain: 'Revisa cómo escribiste tu correo (por ejemplo gmail.com).',
      disposable_email: 'Usa un correo permanente, por favor.', email_mismatch: 'Los dos correos no coinciden.',
      bounce_risk: 'No podemos enviar a este correo. Usa otro, por favor.', rate_limited: 'Demasiados intentos. Inténtalo más tarde.',
      too_many: 'Ya tienes muchos avisos activos con este correo.', in_stock: '¡Buenas noticias! Esta talla ya está disponible.',
      empty: 'Escribe tu correo.', _: 'Algo salió mal. Inténtalo de nuevo.' }
  } : {
    h: "Notify me when it's back",
    sub: function (s) { return (s ? 'Size ' + s + ' is sold out. ' : 'This item is sold out. ') + "Leave your email and we'll send one email when it's back."; },
    email: 'Email', confirm: 'Confirm email',
    optin: 'Yes, I want to receive emails from BAEZ about drops and exclusive promotions. I can unsubscribe at any time.',
    btn: 'Notify me', sending: 'Sending…',
    done: function (s) { return "We'll let you know when " + (s ? s : 'this item') + ' is back in stock'; },
    doneSub: "We'll send one email as soon as it's available again.",
    already: function (s) { return "You're already signed up for " + (s ? 'size ' + s : 'this item') + ". We'll let you know when it's back."; },
    bell: "Sold out: get notified when it's back", bellOn: "You're signed up for this size",
    pick: "Choose your size above, then leave your email. We'll send one email when it's back.",
    mean: 'Did you mean', fix: 'Fix it',
    err: { invalid_email: 'Check your email address.', typo_domain: 'Check the spelling of your email (for example gmail.com).',
      disposable_email: 'Please use a permanent email address.', email_mismatch: "The two emails don't match.",
      bounce_risk: "We can't send to this email. Please use a different one.", rate_limited: 'Too many tries. Please try again later.',
      too_many: 'You already have a lot of alerts on this email.', in_stock: 'Good news! This size is available now.',
      empty: 'Enter your email.', _: 'Something went wrong. Please try again.' }
  };
  var BELL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5.5-6.84V3.5a1.5 1.5 0 0 0-3 0v.66A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var EMAIL_RE = /^[a-zA-Z0-9._+\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,}$/;
  // Same lists the server (restock-email-signup) uses, so the confirm box only appears for an address the server will accept.
  var TYPO = ('gmial.com gmai.com gmal.com gnail.com gmil.com gmaill.com gmailcom gmaik.com gmaiil.com gmale.com gamil.com gmailc.om gemail.com gmail.con gmail.com.com gmaio.com gamail.com mgali.com vmail.com ' +
    'yaho.com yhoo.com yahooo.com yahoo.cm yaoo.com yhaoo.com yahho.com yahoocom hotnail.com hotmal.com hotmial.com hotmaill.com hotmail.cm hoatmail.com hotamail.com hotmaik.com hmail.com hitmail.com hotmail.con.com ' +
    'outloook.com outlok.com outlock.com outllok.com outlookcom iclod.com iclould.com icoud.com icloudcom icluod.com aicloud.com aool.com aol.cm aoll.com live.cm live.co protonmai.com protonmial.com').split(' ');
  var DISPOSABLE = ('mailinator.com mailinator.net mailinator.org 10minutemail.com 10minutemail.net 10minutemail.org guerrillamail.com guerrillamail.net guerrillamail.org guerrillamail.biz guerrillamail.de sharklasers.com ' +
    'grr.la guerrillamailblock.com pokemail.net spam4.me yopmail.com yopmail.net yopmail.fr temp-mail.org tempmail.com tempmail.net tempmail.plus tempail.com temp-mail.ru throwawaymail.com throwaway.email throwaway.com ' +
    'maildrop.cc maildrop.ga maildrop.gq maildrop.ml trashmail.com trashmail.de trashmail.net dispostable.com mytrashmail.com getairmail.com mohmal.com emailondeck.com fakemail.net fakeinbox.com mintemail.com mt2014.com ' +
    'spambox.us spamgourmet.com trbvm.com trbvn.com mailnesia.com mailcatch.com nada.email nada.ltd moakt.com tmail.ws getnada.com inboxkitten.com tempinbox.com discard.email mailsac.com').split(' ');
  // Near-miss domains: one or two letters off a common provider (gmali.com, gmail.co, hotmial.com, yaho.com.mx…).
  // Real providers that happen to look similar (ymail.com, mail.com, yahoo.ca…) are allowed.
  var POPULAR = ['gmail.com', 'hotmail.com', 'yahoo.com', 'outlook.com', 'icloud.com', 'live.com', 'aol.com',
    'protonmail.com', 'hotmail.es', 'outlook.es', 'yahoo.com.mx', 'live.com.mx', 'outlook.com.mx', 'prodigy.net.mx',
    'comcast.net', 'att.net', 'sbcglobal.net', 'verizon.net', 'baezonline.com'];
  var REAL = POPULAR.concat(['me.com', 'msn.com', 'mail.com', 'ymail.com', 'gmx.com', 'gmx.net', 'gmx.us', 'mac.com', 'aim.com', 'email.com', 'zoho.com', 'cox.net',
    'rocketmail.com', 'proton.me', 'pm.me', 'live.ca', 'yahoo.ca', 'hotmail.ca', 'yahoo.es', 'yahoo.fr', 'yahoo.co.uk', 'hotmail.co.uk',
    'hotmail.fr', 'hotmail.it', 'live.co.uk', 'outlook.fr', 'live.cl', 'outlook.cl', 'yahoo.com.ar', 'hotmail.com.ar', 'live.com.ar',
    'hotmail.com.br', 'yahoo.com.br', 'gmail.co.uk', 'yahoo.de', 'gmx.de', 'web.de', 'qq.com', '163.com', 'naver.com', 'baez.bz']);
  function editDistance(a, b) {   // optimal string alignment (swaps of two neighbouring letters count as 1)
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) { d[0][j] = j; }
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      var c = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
    }
    return d[a.length][b.length];
  }
  function suggestDomain(domain) {   // returns the provider they probably meant, or ''
    if (!domain || REAL.indexOf(domain) > -1) return '';
    var best = '', bestD = 9, name = domain.split('.')[0], tld = domain.slice(name.length);
    for (var k = 0; k < POPULAR.length; k++) {
      var p = POPULAR[k], pName = p.split('.')[0], dd;
      // Short provider names (aol, att, live): only an ending typo on the exact name (aol.co, att.ne) — a different
      // name that happens to be close (sol.com, acme.com) is a real company domain.
      if (p.length < 9) dd = name === pName ? editDistance(tld, p.slice(pName.length)) : 9;
      else dd = editDistance(domain, p);
      if (dd < bestD) { bestD = dd; best = p; }
    }
    if (bestD === 1 || (bestD === 2 && domain.length >= 9)) return best;
    return '';
  }
  // Ending typos on any domain (me.ckm, company.cpm, school.edy, site.nett): one letter off .com/.net/.org/.edu and
  // not a real ending people use. Real endings that happen to be close (.co, .eu, .ne, .pet…) are allowed.
  var REAL_TLD = ['co', 'eu', 'ne', 'et', 'new', 'pet', 'vet', 'bet', 'nec', 'ong', 'cat', 'car', 'cab', 'cal', 'cfd'];
  function fixTld(domain) {
    var i = domain.lastIndexOf('.'); if (i < 1) return '';
    var tld = domain.slice(i + 1);
    if (REAL_TLD.indexOf(tld) > -1) return '';
    var ends = ['com', 'net', 'org', 'edu'];
    for (var k = 0; k < ends.length; k++) if (tld !== ends[k] && editDistance(tld, ends[k]) === 1) return domain.slice(0, i + 1) + ends[k];
    return '';
  }
  function fixDomain(domain) { return suggestDomain(domain) || fixTld(domain); }
  function checkEmail(e) {
    if (!e) return 'empty';
    if (e.length > 254 || !EMAIL_RE.test(e) || e.indexOf('..') > -1) return 'invalid_email';
    var at = e.lastIndexOf('@'), local = e.slice(0, at), domain = e.slice(at + 1);
    if (!local || local.length > 64 || domain.length < 3) return 'invalid_email';
    if (TYPO.indexOf(domain) > -1 || fixDomain(domain)) return 'typo_domain';
    if (DISPOSABLE.indexOf(domain) > -1) return 'disposable_email';
    return 'ok';
  }
  function fixedEmail(e) {   // "dexinsf@gmali.com" -> "dexinsf@gmail.com" ('' when there's no confident fix)
    var at = e.lastIndexOf('@'); if (at < 1) return '';
    var d = fixDomain(e.slice(at + 1)); return d ? e.slice(0, at + 1) + d : '';
  }
  function escH(x) { return String(x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var uid = 0;
  // One box per form. The quick-buy pop-up redraws its whole content on every size tap; we put the same box back
  // straight away so the sheet doesn't shrink and grow again (the 'bounce') and a typed email isn't lost.
  var boxes = {};

  // Sizes this browser already signed up for (variant id -> time). Browser storage can be off; then the server still says "already".
  function signed() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function isSigned(id) { return !!signed()[id]; }
  function markSigned(id) { try { var m = signed(); m[id] = Date.now(); localStorage.setItem(STORE_KEY, JSON.stringify(m)); } catch (e) {} }

  function sizeLabel(v) { var s = (v && (v.public_title || v.title)) || ''; return s === 'Default Title' ? '' : s; }
  // The theme pre-selects a size when the page opens (the first one when everything is sold out).
  // A sign-up only counts once the shopper has actually tapped a size, so nobody gets signed up for a size they didn't pick.
  var chosen = {};
  function needsChoice(formId) {
    var picker = pickerFor(formId);
    if (!picker) return false;
    return picker.querySelectorAll('label.block-swatch, label.thumbnail-swatch, label.color-swatch, select option').length > 1;
  }
  function isChosen(formId) { return !needsChoice(formId) || !!chosen[formId]; }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[type="radio"][form], select[form]') && t.closest('variant-picker')) {
      chosen[t.getAttribute('form')] = true;
      setTimeout(refreshAll, 0);   // show the email fields right away; don't wait for the theme to finish switching sizes
    }
  }, true);
  document.addEventListener('variant:change', function (e) { if (e.target && e.target.id) chosen[e.target.id] = true; }, true);
  function pickerFor(formId) { return formId ? document.querySelector('variant-picker[form-id="' + formId + '"]') : null; }

  // Product JSON per handle (to know which variant each size button stands for).
  var products = {}, productData = {};
  function productJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (!products[handle]) products[handle] = fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { productData[handle] = p; return p; }).catch(function () { return null; });
    return products[handle];
  }
  // The size the shopper has tapped, read straight from the size buttons (the theme updates its own record a moment later).
  function tappedVariant(picker) {
    var p = productData[picker.getAttribute('handle')];
    if (!p || !p.variants) return null;
    var opts = [];
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (inp) {
      var lab = picker.querySelector('label[for="' + inp.id + '"]');
      if (lab) opts[Number(inp.getAttribute('data-option-position') || 1) - 1] = (lab.textContent || '').trim();
    });
    picker.querySelectorAll('select').forEach(function (sel, i) { if (sel.selectedOptions[0]) opts[i] = sel.selectedOptions[0].value; });
    if (!opts.length) return null;
    return p.variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); }) || null;
  }

  function currentVariant(formId) {
    var picker = pickerFor(formId), v = null;
    if (picker && chosen[formId]) v = tappedVariant(picker);
    if (!v) { try { v = picker && picker.selectedVariant; } catch (e) {} }
    if ((!v || !v.id) && picker) { try { v = JSON.parse((picker.querySelector('script[data-variant]') || {}).textContent || 'null'); } catch (e) {} }
    if (v && v.id) return { id: String(v.id), available: !!v.available, size: sizeLabel(v), options: v.options || [] };
    var form = formId && document.getElementById(formId);
    var input = form && form.querySelector('input[name="id"]');
    var btn = form && form.querySelector('buy-buttons button[type="submit"]');
    if (!input || !input.value) return null;
    return { id: String(input.value), available: !(btn && btn.disabled), size: '', options: [] };
  }

  // Bell on every sold-out size button; green when this browser signed up for that size.
  function decorate(formId) {
    var picker = pickerFor(formId);
    if (!picker) return;
    productJson(picker.getAttribute('handle')).then(function (p) {
      var cur = currentVariant(formId);
      picker.querySelectorAll('label.block-swatch').forEach(function (lab) {
        var input = lab.getAttribute('for') && document.getElementById(lab.getAttribute('for'));
        var pos = input ? Number(input.getAttribute('data-option-position') || 1) : 1;
        var text = (lab.textContent || '').trim();
        var vid = null;
        if (p && p.variants) {
          var want = (cur && cur.options.length ? cur.options.slice() : []);
          want[pos - 1] = text;
          var match = p.variants.find(function (x) { return x.options.every(function (o, i) { return i === pos - 1 ? o === text : (want[i] == null || o === want[i]); }); });
          if (match) vid = String(match.id);
        }
        var soldOut = lab.classList.contains('is-disabled');
        var on = soldOut && vid && isSigned(vid);
        lab.classList.toggle('bz-soldout', soldOut);
        lab.classList.toggle('bz-signed', !!on);
        var bell = lab.querySelector('.bz-bell');
        if (soldOut && !bell) { bell = document.createElement('span'); bell.className = 'bz-bell'; bell.innerHTML = BELL; lab.appendChild(bell); }
        if (!soldOut && bell) bell.remove();
        if (bell) lab.setAttribute('title', on ? T.bellOn : T.bell); else lab.removeAttribute('title');
      });
    });
  }

  function build(buy) {
    var formId = buy.getAttribute('form');
    var pf = buy.closest('product-form');
    if (!formId || !pf || pf.nextElementSibling && pf.nextElementSibling.classList.contains('bz-notify')) return;
    var kept = boxes[formId];
    if (kept && !kept.isConnected) { pf.insertAdjacentElement('afterend', kept); kept._bzRefresh(); return; }
    var n = ++uid;
    var box = document.createElement('div');
    box.className = 'bz-notify';
    boxes[formId] = box;
    box.hidden = true;
    box.setAttribute('data-form', formId);
    box.setAttribute('data-src', buy.closest('quick-buy-modal, .quick-buy-drawer, [id^="quick-buy"]') ? 'quickbuy' : 'product');
    box.innerHTML =
      '<div class="bz-notify__ask">' +
        '<p class="bz-notify__h"><span class="bz-notify__hb">' + BELL + '</span>' + T.h + '</p>' +
        '<p class="bz-notify__sub"></p>' +
        '<div class="bz-notify__form">' +
        '<label class="bz-notify__lbl" for="bzn-e' + n + '">' + T.email + '</label>' +
        '<input class="bz-notify__in" id="bzn-e' + n + '" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="' + T.email + '">' +
        '<p class="bz-notify__emsg" role="alert"></p>' +
        '<div class="bz-notify__c" hidden>' +
          '<label class="bz-notify__lbl" for="bzn-c' + n + '">' + T.confirm + '</label>' +
          '<input class="bz-notify__in" id="bzn-c' + n + '" type="email" inputmode="email" autocomplete="off" autocapitalize="off" spellcheck="false" placeholder="' + T.confirm + '">' +
        '</div>' +
        '<p class="bz-notify__msg" role="status" aria-live="polite"></p>' +
        '<div class="bz-notify__hp" aria-hidden="true"><label>Website<input type="text" tabindex="-1" autocomplete="off"></label></div>' +
        '<label class="bz-notify__opt"><input type="checkbox"> <span>' + T.optin + '</span></label>' +
        '<button type="button" class="bz-notify__btn">' + T.btn + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="bz-notify__done" hidden role="status" aria-live="polite">' +
        '<div class="bz-notify__ok">' + CHECK + '<span></span></div>' +
        '<p class="bz-notify__oksub"></p>' +
      '</div>';
    pf.insertAdjacentElement('afterend', box);
    // Product page opened from a link with ?variant= (e.g. the back-in-stock email) = that size was picked.
    var pk = pickerFor(formId);
    if (pk && pk.hasAttribute('update-url') && new URLSearchParams(location.search).get('variant')) chosen[formId] = true;
    var formEl = box.querySelector('.bz-notify__form');

    var ins = box.querySelectorAll('.bz-notify__in'), em = ins[0], cf = ins[1];
    var cwrap = box.querySelector('.bz-notify__c'), hp = box.querySelector('.bz-notify__hp input');
    var opt = box.querySelector('.bz-notify__opt input'), btn = box.querySelector('.bz-notify__btn');
    var msg = box.querySelector('.bz-notify__msg'), ask = box.querySelector('.bz-notify__ask'), done = box.querySelector('.bz-notify__done');
    var emsg = box.querySelector('.bz-notify__emsg');
    var busy = false, timer = null;

    // The confirm box only appears once the first email passes the checks (format, misspelled domain, throwaway address).
    // While typing nothing is flagged; a problem is shown when they leave the field or try to send.
    function firstOk() { return checkEmail(em.value.trim().toLowerCase()) === 'ok'; }
    function showFirstError() {
      var e = em.value.trim().toLowerCase(), c = checkEmail(e), fix = c === 'typo_domain' ? fixedEmail(e) : '';
      if (fix) {
        if (emsg.getAttribute('data-fix') !== fix) {   // don't redraw an identical suggestion (a tap on "Fix it" would be lost)
          emsg.innerHTML = T.mean + ' <b>' + escH(fix) + '</b>? <button type="button" class="bz-notify__fix">' + T.fix + '</button>';
          emsg.setAttribute('data-fix', fix);
          var fb = emsg.querySelector('.bz-notify__fix');
          fb.addEventListener('mousedown', function (ev) { ev.preventDefault(); });   // keep focus in the field so nothing redraws mid-tap
          fb.onclick = function () {
            em.value = fix; emsg.textContent = ''; emsg.removeAttribute('data-fix'); em.classList.remove('is-bad'); syncConfirm(); if (!cwrap.hidden) cf.focus();
          };
        }
      } else { emsg.removeAttribute('data-fix'); emsg.textContent = c === 'ok' || c === 'empty' ? '' : (T.err[c] || T.err.invalid_email); }
      em.classList.toggle('is-bad', !!emsg.textContent);
      if (emsg.textContent) inView(emsg);
      return c;
    }
    function syncConfirm() {
      if (firstOk()) { if (cwrap.hidden) cwrap.hidden = false; }
      else if (!cwrap.hidden) { cwrap.hidden = true; cf.value = ''; }
    }
    em.addEventListener('input', function () {
      emsg.textContent = ''; emsg.removeAttribute('data-fix'); em.classList.remove('is-bad'); say('');
      if (!firstOk() && !cwrap.hidden) { cwrap.hidden = true; cf.value = ''; }
      clearTimeout(timer);
      syncConfirm();   // good address -> confirm box right away (also covers autofill)
      // Short pause after typing: a misspelled or throwaway domain shows the fix without waiting for them to leave the field.
      timer = setTimeout(function () {
        var c = checkEmail(em.value.trim().toLowerCase());
        if (c === 'typo_domain' || c === 'disposable_email') showFirstError();
      }, 350);
    });
    em.addEventListener('blur', function () { clearTimeout(timer); if (em.value.trim()) showFirstError(); syncConfirm(); if (!cwrap.hidden && cf.value.trim()) checkMatch(true); });
    ['paste', 'drop'].forEach(function (ev) { cf.addEventListener(ev, function (e) { e.preventDefault(); }); });
    var ctimer = null;
    function checkMatch(final) {
      var a = em.value.trim().toLowerCase(), b = cf.value.trim().toLowerCase();
      if (!b) { say(''); return; }
      if (a === b) { say(''); cf.classList.remove('is-bad'); return; }
      if (final || b.length >= a.length) { say(T.err.email_mismatch, 'err'); cf.classList.add('is-bad'); }
    }
    cf.addEventListener('input', function () { cf.classList.remove('is-bad'); if (msg.classList.contains('is-err')) say(''); clearTimeout(ctimer); ctimer = setTimeout(function () { checkMatch(false); }, 350); });
    cf.addEventListener('blur', function () { clearTimeout(ctimer); checkMatch(true); });
    [em, cf].forEach(function (i) { i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } }); });
    btn.addEventListener('click', send);

    function say(text, kind) { msg.textContent = text; msg.className = 'bz-notify__msg' + (kind ? ' is-' + kind : ''); if (text) inView(msg); }
    function inView(el) { setTimeout(function () { try { el.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {} }, 60); }
    function showDone(v, wasAlready) {
      ask.hidden = true; done.hidden = false; box.classList.add('is-signed');
      done.querySelector('.bz-notify__ok span').textContent = T.done(v.size);
      done.querySelector('.bz-notify__oksub').textContent = wasAlready ? T.already(v.size) : T.doneSub;
    }
    function showAsk(v) {
      ask.hidden = false; done.hidden = true; formEl.hidden = false; box.classList.remove('is-signed');
      box.querySelector('.bz-notify__sub').textContent = T.sub(v.size);
    }
    function showPick() {
      ask.hidden = false; done.hidden = true; formEl.hidden = true; box.classList.remove('is-signed');
      box.querySelector('.bz-notify__sub').textContent = T.pick;
    }
    function send() {
      if (busy) return;
      var v = currentVariant(formId); if (!v) return;
      if (!isChosen(formId)) { showPick(); return; }
      if (isSigned(v.id)) { showDone(v, true); return; }
      var e1 = em.value.trim().toLowerCase(), e2 = cf.value.trim().toLowerCase();
      if (!e1) { say(T.err.empty, 'err'); em.focus(); return; }
      if (showFirstError() !== 'ok') { em.focus(); return; }
      if (cwrap.hidden || !e2) { cwrap.hidden = false; say(''); cf.focus(); return; }
      if (e1 !== e2) { say(T.err.email_mismatch, 'err'); cf.focus(); return; }
      busy = true; btn.disabled = true; btn.textContent = T.sending; say('');
      fetch(ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ variant_id: v.id, email: e1, email_confirm: e2, lang: ES ? 'es' : 'en', familia: opt.checked, hp: hp.value, source: box.getAttribute('data-src') })
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (j) {
          if (j && j.ok) {
            markSigned(v.id);
            showDone({ id: v.id, size: sizeLabel({ title: j.size }) || v.size }, !!j.already);
            decorate(formId);
          } else say(T.err[(j && j.error_code) || '_'] || T.err._, 'err');
        })
        .catch(function () { say(T.err._, 'err'); })
        .then(function () { busy = false; btn.disabled = false; btn.textContent = T.btn; });
    }
    box._bzRefresh = function () {
      var v = currentVariant(formId);
      var show = !!v && !v.available;
      var need = show && !isChosen(formId);
      box.hidden = !show;
      // Until a size is tapped, the pre-selected sold-out size doesn't look chosen.
      var pk2 = pickerFor(formId); if (pk2) pk2.classList.toggle('bz-unchosen', need);
      if (show) {
        if (need) { showPick(); box.removeAttribute('data-vid'); }
        else if (isSigned(v.id)) showDone(v, false);
        else if (box.getAttribute('data-vid') !== v.id || !done.hidden || formEl.hidden) showAsk(v);
      }
      if (v && !need) box.setAttribute('data-vid', v.id);
      decorate(formId);
    };
    box._bzRefresh();
  }

  function scan() { document.querySelectorAll('buy-buttons[form]').forEach(build); refreshAll(); }
  function refreshAll() { document.querySelectorAll('.bz-notify').forEach(function (b) { b._bzRefresh && b._bzRefresh(); }); }

  document.addEventListener('variant:change', function () { setTimeout(refreshAll, 0); });
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') setTimeout(refreshAll, 0); });
  // The theme redraws the size buttons on every change and the quick-buy pop-up loads later, so watch for new markup.
  var queued = false;
  new MutationObserver(function (list) {
    if (queued) return;
    for (var i = 0; i < list.length; i++) {
      var t = list[i].target;
      if (t.closest && t.closest('.bz-notify')) continue;
      var added = list[i].addedNodes;
      for (var k = 0; k < added.length; k++) {
        var a = added[k];
        if (a.nodeType === 1 && !(a.classList && (a.classList.contains('bz-bell') || a.classList.contains('bz-notify')))) {
          // Redrawn product form (quick-buy size tap): fix it up before the screen repaints, so nothing jumps.
          if ((a.matches && a.matches('buy-buttons[form], product-form')) || (a.querySelector && a.querySelector('buy-buttons[form]'))) { scan(); return; }
          queued = true; setTimeout(function () { queued = false; scan(); }, 120); return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();

/* ── 15. Light / dark button (2026-11-03) ────────────────────────────────────
   The page follows the phone/computer setting (white when there is none).
   Tapping the sun/moon button in the top bar switches it and remembers the
   choice in this browser (bz_theme). A one-line script in theme.liquid <head>
   applies the remembered choice before the page draws, so there's no flash. */
(function () {
  var KEY = 'bz_theme';
  var root = document.documentElement;
  function systemDark() { return !!(window.matchMedia && matchMedia('(prefers-color-scheme: dark)').matches); }
  function current() { var a = root.getAttribute('data-bz-theme'); return a === 'dark' || a === 'light' ? a : (systemDark() ? 'dark' : 'light'); }
  function label(btn) {
    var es = /^es/i.test(root.lang || '');
    var toDark = current() === 'light';
    btn.setAttribute('aria-label', es ? (toDark ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro') : (toDark ? 'Switch to dark mode' : 'Switch to light mode'));
    btn.setAttribute('title', btn.getAttribute('aria-label'));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bz-mode');
    if (!btn) return;
    e.preventDefault();
    var next = current() === 'dark' ? 'light' : 'dark';
    root.setAttribute('data-bz-theme', next);
    try { localStorage.setItem(KEY, next); } catch (err) {}
    document.querySelectorAll('.bz-mode').forEach(label);
  });
  function init() { document.querySelectorAll('.bz-mode').forEach(label); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Phone switches between light and dark (e.g. at sunset) while the page is open and no choice was saved
  try { matchMedia('(prefers-color-scheme: dark)').addEventListener('change', init); } catch (err) {}
})();

/* ── 16. "Notify me" button on sold-out product cards (2026-11-03) ───────────
   In-stock cards have the theme's "+" quick-buy button bottom-right; sold-out cards
   have nothing. This adds a "Notify me" pill in the same spot. It opens the same
   quick-buy pop-up (the theme loads it on demand from the product handle), where
   section 14 shows the back-in-stock sign-up box for the sold-out size. */
(function () {
  var ES = /^es/i.test(document.documentElement.lang || '');
  var LABEL = ES ? 'Avísame' : 'Notify me';
  var ARIA = ES ? 'Avísame cuando vuelva' : "Notify me when it's back";
  var BELL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5.5-6.84V3.5a1.5 1.5 0 0 0-3 0v.66A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z"/></svg>';
  var n = 0;
  function add(card) {
    if (card.hasAttribute('data-bz-notify')) return;
    var handle = card.getAttribute('handle');
    var fig = card.querySelector('.product-card__figure');
    var soldOut = card.querySelector('sold-out-badge, .badge--sold-out');
    if (!handle || !fig || !soldOut || card.querySelector('.product-card__quick-add-button')) return;
    card.setAttribute('data-bz-notify', '');
    var id = 'bz-qb-' + handle.replace(/[^a-z0-9_-]/gi, '') + '-' + (++n);
    var modal = document.createElement('quick-buy-modal');
    modal.setAttribute('handle', handle);
    modal.className = 'quick-buy-modal modal';
    modal.id = id;
    card.appendChild(modal);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bz-card-notify';
    btn.setAttribute('aria-controls', id);
    btn.setAttribute('aria-label', ARIA);
    btn.innerHTML = BELL + '<span>' + LABEL + '</span>';
    fig.appendChild(btn);
  }
  function scan() { document.querySelectorAll('product-card[handle]').forEach(add); }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    setTimeout(function () { queued = false; scan(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
